import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useMediaQuery } from '@uidotdev/usehooks'
import { VIRTUAL_TOUR_TABS } from '../../constant'
import './styles.scss'

function TourController({ activeTab, setTab }) {
  const { t } = useTranslation();
  const isPhoneScreen = useMediaQuery('screen and (max-width: 1080px)')

  return (
    <div
      className={classNames({
        'virtual-tour-controller': true,
        'virtual-tour-controller-phone-screen': isPhoneScreen,
      })}
    >
      <div className="virtual-tour-controller-tab-container">
        <button
          className={classNames({
            'virtual-tour-controller-tab-button': true,
            'virtual-tour-controller-tab-button--active': activeTab === VIRTUAL_TOUR_TABS.INTERIOR,
          })}
          onClick={() => setTab(VIRTUAL_TOUR_TABS.INTERIOR)}
          disabled={activeTab === VIRTUAL_TOUR_TABS.INTERIOR}
        >
          {t('tourController.interior')}
        </button>
        <button
          className={classNames({
            'virtual-tour-controller-tab-button': true,
            'virtual-tour-controller-tab-button--active': activeTab === VIRTUAL_TOUR_TABS.EXTERIOR,
          })}
          onClick={() => setTab(VIRTUAL_TOUR_TABS.EXTERIOR)}
          disabled={activeTab === VIRTUAL_TOUR_TABS.EXTERIOR}
        >
          {t('tourController.exterior')}
        </button>
      </div>
    </div>
  )
}

export default TourController
